import { Pipe, PipeTransform } from '@angular/core';
import { Utils } from 'app/custom-class/utils';

/**
 * Resolves the active-language name of a `MultilingualEntity` (university,
 * school, activity, scientific sector, ...) via `Utils.resolveEntityName()`
 * instead of showing its raw `.name` field verbatim — that field is just
 * whichever language it happened to be entered in, not translated.
 *
 * Drop-in replacement for a raw `{{ entity.name }}` binding wherever the
 * entity is a MultilingualEntity with an `id`:
 *   {{ university | entityName }}
 *   {{ schoolUniversity.school | entityName }}
 *
 * `pure: false` so it re-renders on a language change the same way
 * `| translate` does, instead of showing the old language until the next
 * unrelated change-detection pass.
 */
@Pipe({
	name: 'entityName',
	pure: false,
	standalone: true,
})
export class EntityNamePipe implements PipeTransform {
	transform(entity: { id?: string; name?: string } | string | null | undefined): string {
		return Utils.resolveEntityName(entity);
	}
}
